<template>
  <footer class="footer" role="contentinfo">
    <ul class="footer-menu">
      <li class="footer-menu__item">
        <a class="footer-menu__link" href="https://kontur.ru/" target="_blank" rel="noopener noreferrer" @click="handleTrack('toKontur')">
          <strong>СКБ&nbsp;Контур</strong> с&nbsp;1988&nbsp;года
        </a>
      </li>
      <li class="footer-menu__item">
        <a class="footer-menu__link" href="https://kontur.ru/lp/market-tips" target="_blank" rel="noopener noreferrer" @click="handleTrack('About')">
          О&nbsp;сервисе
        </a>
      </li>
      <li class="footer-menu__item">
        <a class="footer-menu__link" href="https://kontur.ru/lp/market-tips/offers" target="_blank" rel="noopener noreferrer" @click="handleTrack('toConditions')">
          Условия пользования
        </a>
      </li>
    </ul>
    <!-- <span>@ {{ new Date().getFullYear() }} Все права защищены</span> -->
  </footer>
</template>

<script>
import JwtService from '@/common/jwt.service'
import ApiService from '@/common/api.service'
import { APP_VERSION } from '@/common/config'
export default {
  name: 'TheFooter',
  props: {
    classes: {
      type: String
    }
  },
  data() {
    return {
      new_version: null,
      isNewVersion: false
    }
  },
  created() {
    if (!JwtService.getAppVersion()) {
      JwtService.saveAppVersion(APP_VERSION)
      this.updateApp()
    } else {
      // this.isNewVersion = false
      // this.$vs.loading()
      ApiService.get_app_version().then(response => {
        this.new_version = response.data
        if (JwtService.getAppVersion() !== this.new_version) {
          this.isNewVersion = false
        } else if (this.new_version !== APP_VERSION) {
          console.log(
            'Версия установленная на сервере не совпадает с текущей. Не удалось обновить приложение'
          )
        }
        // this.$vs.loading.close()
      })
    }
  },
  methods: {
    updateApp() {
      this.$vs.loading()
      JwtService.saveAppVersion(this.new_version)
      window.location.reload(true)
      this.$vs.loading.close()
    },
    handleTrack(label) {
      this.$km_track('Footer', 'Click', label)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/vuesax/_variables';
  .footer {
    margin-top: auto;
    padding: $size-4 0 0;
  }

  .footer-menu {
    display: flex;
    align-items: center;
    min-height: $size-5;
    width: 100%;
    margin-top: auto;
    margin-top: auto;
  }
  .footer-menu__item {
    &+& {
      margin-left: $size-2;
    }
  }
  .footer-menu__link {
    color: rgba(0, 0, 0, 0.48);
    font-size: $font-size-small;
  }

  @media (max-width: 600px) {
    .footer-menu {
      flex-direction: column;
    }
    .footer-menu__item {
      &+& {
        margin-left: 0;
      }
    }
  }
</style>
